import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { Operation } from '../../../models/operation.model';
import { Permission } from '../../../models/permission.model';
import { roleMS } from '../../../models/roleMS.model';
import { ApplicationService } from '../../../services/application/applications.service';
import { RolePermissionMSService } from '../../../services/utils/rolePermissionMS.service';

@Component({
  selector: 'app-rolesapplicationpermission-form',
  providers: [],
  templateUrl: './rolesApplicationPermissionsForm.component.html'
  })

export class RolesApplicationPermissionFormComponent implements OnChanges {

  @Input() set rolePermission(rolePermission: Permission) {
    this._rolePermission = rolePermission;
  }
  get rolePerimission() { return this._rolePermission; }

  _rolePermission: Permission;
  @Input() selectedRole: roleMS;
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  operationsDropwDown: SelectItem[] = [];
  addPermissionForm: FormGroup;
  labelButton: string;
  selectedOperation: any = {};

  selectOperation($event) {
    this.selectedOperation = this.srvRolePermissionMS.operations.find( op => op.id === $event.value) || {};
  }

  constructor(
    private srvRolePermissionMS: RolePermissionMSService,
    private srvApp: ApplicationService
  ) {
  }

  ngOnChanges(changes) {
    if (changes.selectedRole && changes.rolePermission) {
      this.srvRolePermissionMS.getOperations(changes.selectedRole.currentValue).subscribe(res => {
        res.forEach( (op: Operation) => {
          this.operationsDropwDown.push({
            label: op.type + ' / ' + op.operation ,
            value: op.id
          })
        }, this);
        this.operationsDropwDown.sort(function(a, b){
          if (a.label < b.label) {
             return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
       })
        if (changes.rolePermission.currentValue.id) {
          this.addPermissionForm = this.createPermissionForm(changes.rolePermission.currentValue);
          this.labelButton = 'roleMS.btnUpdate';
        } else {
          this.addPermissionForm = this.createPermissionForm(null);
          this.labelButton = 'roleMS.btnCreate';
        }
      });
    }
  }

  savePermission(): void {
    let selectedOP: Operation = this.srvRolePermissionMS.operations.find( op => op.id === this.addPermissionForm.value.operationID);

    if (!selectedOP) {
      return;
    }

    let perm: Permission = {
      id: this._rolePermission.id,
      operationID: selectedOP.id,
      operationName: selectedOP.operation,
      roleID: this.selectedRole.id,
      allowsGET: !!this.addPermissionForm.value.permGet && this.addPermissionForm.value.permGet[0] === 'allowsGET' ? true : false,
      allowsPOST: !!this.addPermissionForm.value.permPost && this.addPermissionForm.value.permPost[0] === 'allowsPOST' ? true : false,
      allowsPUT: !!this.addPermissionForm.value.permPut && this.addPermissionForm.value.permPut[0] === 'allowsPUT' ? true : false,
      allowsDELETE: !!this.addPermissionForm.value.permDelete && this.addPermissionForm.value.permDelete[0] === 'allowsDELETE' ? true : false
    };

    this.onSave.emit(perm);
  }

  private createPermissionForm(rolePermission: Permission): FormGroup {

    let data = rolePermission || this._rolePermission;
    if (data == null) {
      data = new Permission();
    } else {
      this.selectedOperation = this.srvRolePermissionMS.operations.find( op => op.id === data.operationID) || {};
    }

    let permGet;
    let permPost;
    let permPut;
    let permDelete;

    if (data.allowsGET) {
      permGet = ['allowsGET'];
    }
    if (data.allowsPOST) {
      permPost = ['allowsPOST'];
    }
    if (data.allowsPUT) {
      permPut = ['allowsPUT'];
    }
    if (data.allowsDELETE) {
      permDelete = ['allowsDELETE'];
    }
    return new FormGroup({
      'operationID' : new FormControl(data.operationID, Validators.required),
      'permGet': new FormControl(permGet),
      'permPost': new FormControl(permPost),
      'permPut': new FormControl(permPut),
      'permDelete': new FormControl(permDelete)
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationPermissionsForm.component.ts